import React from 'react'
import { useCallback } from 'sb-hooks'
import actions from 'redux/actions'
import { constants, snowplow } from 'common/helpers'
import { Events } from 'common/helpers/analytics/snowplow/config'

import { Button, ButtonProps } from 'components/_new/controls'

import { AddToProps, useAddToButton, getRealUpchargePrice } from '../util'
import messages from '../messages'


export type AddToQueueMetadata = Pick<
  Events['Add to queue front'],
  'placement' | 'sectionTab' | 'recommenderName' | 'page'
>

export type AddToQueueButtonProps = AddToProps<AddToQueueMetadata, AddToQueueMetadata>

// ATTN it should be function, because generics integration with arrow functions is bad
function AddToQueueButton<ComponentProps = ButtonProps>(props: AddToQueueButtonProps & ComponentProps) {
  const action = useCallback(({ product, metadata }) => (
    actions.models.queue.addItem(product, metadata)
  ), [])

  const onAdd = useCallback((props: AddToQueueButtonProps) => {
    const {
      product: { id, name, category, upchargePrice },
      snowplowMetadata: { placement, recommenderName },
    } = props

    const realUpchargePrice = getRealUpchargePrice(upchargePrice)

    snowplow.track(constants.snowplowEvents.addToQueue, {
      productId: id,
      productName: name,
      productCategory: category,
      upchargePrice: realUpchargePrice,
      placement,
      recommenderName,
    }, false)
  }, [])

  const { handleClick } = useAddToButton({ action, onAdd, props })

  const { component, ...rest } = props
  const Element = component || Button

  return (
    <Element
      {...rest}
      onClick={handleClick}
    />
  )
}

AddToQueueButton.defaultProps = {
  title: messages.addToQueue,
  dataTestId: 'queueAddButton',
}


export default AddToQueueButton
